<template>
        <div style="width: 100%;height: 100%">
                <router-view v-if="isRouterAlive"></router-view>
                <el-dialog
                        title="提示"
                        :visible.sync="dialogVisibleFlag"
                        width="30%">
                        <span>检测到您的CA锁已拔出，是否要立即退出 ？ <em style="font-style: normal;color: #3E8EF7;font-size: 20px">{{setTimeNum}}</em></span>
                        <span slot="footer" class="dialog-footer">
                              <el-button type="primary" @click="dialogVisible">确 定</el-button>
                        </span>
                </el-dialog>
        </div>
<!--    <transition name="fade">-->

<!--    </transition>-->
</template>

<script>
        import {initCa, getCaInfo, SignData} from './utils/CertTools'
        export default {
                provide(){
                        return this.reload
                },
                data(){
                        return {
                                isRouterAlive:true,
                                dialogVisibleFlag:false,
                                setTimeNum:10,
                        }
                },
                mounted() {
                      //  this.checkCAMessage();
                },
                methods:{
                        checkCAMessage(){
                                window.interval = setInterval(()=>{
                                        if(!!localStorage.getItem('token')){
                                                        getCaInfo((certInfo) => {
                                                                if(!certInfo.caLegalCode){
                                                                        window.clearInterval(window.interval);
                                                                        this.dialogVisibleFlag = true;
                                                                        this.setTimeToLogin();
                                                                }
                                                        })
                                        }
                                },3000);
                        },
                        dialogVisible(){
                                this.setTimeNum = 10;
                                this.dialogVisibleFlag = false;
                                window.clearInterval(window.interval);
                                window.clearInterval(window.setTime);
                                localStorage.removeItem('token');
                                this.$router.go(0);
                                this.$router.push('/login');
                                this.checkCAMessage();
                        },
                        setTimeToLogin(){
                                if(this.dialogVisibleFlag){
                                        window.setTime = setInterval(()=>{
                                                this.setTimeNum -= 1;
                                                if(this.setTimeNum == 0){
                                                        this.setTimeNum = 10;
                                                        this.dialogVisibleFlag = false;
                                                        window.clearInterval(window.setTime);
                                                        window.clearInterval(window.interval);
                                                        localStorage.removeItem('token');
                                                        this.$router.go(0);
                                                        this.$router.push('/login');
                                                        this.checkCAMessage();
                                                }
                                        },1000)
                                }
                        },
                        reload(){
                                this.isRouterAlive = false;
                                this.$nextTick(()=>{
                                        this.isRouterAlive = true;
                                })
                        }
                }
        }
</script>

<style lang="scss">
    *{
        margin: 0;
        padding: 0;
        list-style-type: none;
        box-sizing: border-box;
    }
    html,body{
        width: 100%;
        height: 100%;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    }
</style>
